/**
 * Transforms a square matrix into a heatmap data array.
 *
 * @param {number[][]} matrix - The square matrix to be transformed.
 * @param {string[]} labels - The list of labels corresponding to matrix rows/columns.
 * @returns {Object[]} heatmapData - The array of objects containing 'x', 'y', and 'value'.
 */
const transformMatrixToHeatmap = (matrix, labels) => {
  if (!Array.isArray(matrix) || !Array.isArray(labels)) {
    throw new Error('Both matrix and labels should be arrays.');
  }

  if (matrix.length !== labels.length) {
    throw new Error('The length of labels should match the size of the matrix.');
  }

  const heatmapData = [];

  for (let i = 0; i < matrix.length; i++) {
    for (let j = 0; j < matrix[i].length; j++) {
      heatmapData.push({
        x: labels[i],
        y: labels[j],
        value: matrix[i][j] * 100
      });
    }
  }

  return heatmapData;
};



export {
    transformMatrixToHeatmap
}